import React from "react";
import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../_app/types";

const RadioChecked = ({ size, colorCustom }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 8.5C0.5 4.35786 3.85786 1 8 1C12.1421 1 15.5 4.35786 15.5 8.5C15.5 12.6421 12.1421 16 8 16C3.85786 16 0.5 12.6421 0.5 8.5Z"
          stroke={colorCustom ? colorCustom : theme.palette.text.primary}
        />
        <path
          d="M3 8.5C3 5.73858 5.23858 3.5 8 3.5C10.7614 3.5 13 5.73858 13 8.5C13 11.2614 10.7614 13.5 8 13.5C5.23858 13.5 3 11.2614 3 8.5Z"
          fill={colorCustom ? colorCustom : theme.palette.text.primary}
        />
      </svg>
    </SvgIcon>
  );
};

export default RadioChecked;
